import React from "react";
import clsx from "clsx";

interface BookingLoginTableHeadProps {
    className?: string;
    children: React.ReactNode | React.ReactNode[];
}

const BookingLoginTableHead = (props: BookingLoginTableHeadProps) => {
    return (
        <div
            className={clsx(
                "BookingLoginTableHead grid items-center py-4 font-medium divide-x divide-arbo-borderGray border-b-2 border-[#EEEEEE] bg-[#EEEEEE] text-black rounded-tl-md rounded-tr-md",
                props.className
            )}
        >
            {props.children}
        </div>
    );
};

export default BookingLoginTableHead;
